<div class="text-center">
  <div #container style="display: flex; justify-content: center;">
    <canvas class="ion-margin-end" #canvas style="flex-grow: 0; overflow: auto;"
            (mousedown)="mouseDown($event)"
            (mousemove)="mouseMove($event)"
            (mouseup)="mouseUp()"
            (dblclick)="mouseDbClick($event)">
    </canvas>
    <div style="display: flex; flex-direction: column; flex-grow: 0; align-items: center; align-self: end;">
      <div style="max-width: 40px;" class="ion-margin-end">
        <span>Ep.</span>
        <app-number-input [parentFormGroup]="formGroup" parentFormControlName="thickness" [minValue]="1"></app-number-input>
      </div>
      <div style="max-width: 50px;" class="ion-margin-end">
        <span>Taille</span>
        <app-number-input [parentFormGroup]="formGroup" parentFormControlName="size" [minValue]="1"></app-number-input>
      </div>
      <div style="max-width: 50px;" class="ion-margin-end">
        <span>Coul.</span>
        <input [(colorPicker)]="selectedColor" [style.background]="selectedColor" style="height: 30px; width: 100%;" />
      </div>
      <div style="max-width: 50px;" class="ion-margin-end">
        <span>Rempl.</span>
        <app-checkbox-input [parentFormGroup]="formGroup" parentFormControlName="fill"></app-checkbox-input>
      </div>
      <div style="max-width: 50px;">
        <app-button iconName="arrow-back" [label]="'' + historyStates.length" (clickEvent)="undo()"></app-button>
      </div>
      </div>
  </div>
  <div>
    <app-button [fill]="'draw' === selectedOption ? 'solid' : 'clear'"
                iconName="ease-in-out"
                size="small"
                label="Libre"
                (clickEvent)="optionSelected('draw')">
    </app-button>
    <app-button *ngFor="let shape of shapeOptions"
                size="small"
                [fill]="shape.label === selectedOption ? 'solid' : 'clear'"
                [iconName]="resolveShapeIconName(shape.label)"
                [label]="shape.value"
                (clickEvent)="optionSelected(shape.label)">
    </app-button>
  </div>
</div>


